<template>
  <div>
    <form role="form" @submit.prevent="onSubmitForm()">
    <h6 class="mb-0">{{ titlePage }}</h6>
    <p class="mb-0 text-sm">{{ subtitlePage }}</p>
    <hr class="my-3 horizontal dark" />
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label for="serviceName" class="form-label">Service Name</label>
          <input id="serviceName" type="text" class="form-control" v-model="record.service_name" required/>
        </div>          
      </div>
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label for="basePrice" class="form-label">Product Type</label>
          <select class="dataTable-selector form-select form-select-sm" v-model="record.product_type" required>
            <option v-for="item in unitTypes" :value="item" :key="item" >{{ item }}</option>                        
          </select>          
        </div>            
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-12">
        <div class="form-group">
          <label for="description" class="form-label">Description</label>
          <quill-editor theme="snow" :options="options" v-model:content="record.description" contentType="html"></quill-editor>

        </div>          
      </div>
    </div>
   
    
    <hr />
    <div class="row mb-3 ms-3" v-for="(item, key) in record.pricing_models" :key="key">
      <div class="col-11">
        <div class="row">
          <div class="col-3">
            <label for="pricinglabel" class="form-label">Pricing Label</label>
            <div class="input-group">
               <input id="pricinglabel" type="text" class="form-control" v-model="item.label.en" required />
            </div>          
          </div>  
          <div class="col-3">
            <label for="pricinglabelId" class="form-label">Pricing Label Bahasa</label>
            <div class="input-group">
              
              <input id="pricinglabelId" type="text" class="form-control" v-model="item.label.id" />
            </div>          
          </div>  
          <div class="col-3">
            <label for="pricinglabel" class="form-label">Hint</label>
            <div class="input-group">
               <input id="pricinglabel" type="text" class="form-control" v-model="item.hint.en" />
            </div>          
          </div>  
          <div class="col-3">
            <label for="pricinglabel" class="form-label">Hint Bahasa</label>
            <div class="input-group">
              
              <input id="pricinglabelId" type="text" class="form-control" v-model="item.hint.id" />
            </div>          
          </div>  
        </div>
        <div class="row">          
          <div class="col-3">
            <label for="basePrice" class="form-label">Price</label>
            <div class="input-group">
              
              <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon1">Rp</span>
              </div>
              <input id="basePrice" type="number" class="form-control" v-model="item.base_price" required min="0" style="padding: 0.5rem 0.75rem;border-right:1px solid #d2d6da !important"/>
            </div>          
          </div>  
          
          <div class="col-3">
            <div class="form-group">
              <label for="min_unit" class="form-label">Valid Min</label>
              <input id="min_unit" type="number" class="form-control" v-model="item.min_unit" required min="0"/>
            </div>             
          </div>    
          
          <div class="col-3">
            <div class="form-group">
              <label for="max_unit" class="form-label">Valid Max</label>
              <input id="max_unit" type="number" class="form-control" v-model="item.max_unit" required min="0"/>
            </div>             
          </div>  
          
          <div class="col-3">
            <div class="form-group">
              <label for="is_active" class="form-label"></label>
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" name="is_active" id="is_active" :checked="item.is_active" v-model="item.is_active"/>
                <label class="form-check-label" for="is_active">
                  Is Active
                </label>
              </div>
            </div>             
          </div>   
        </div>
        <div class="row">
          <div class="col-6">
            <label for="pricinglabel" class="form-label">Description</label>
            <div class="input-group">
              <quill-editor :options="options" theme="snow" v-model:content="item.description.en" contentType="html"></quill-editor>
            </div>          
          </div>  
          <div class="col-6">
            <label for="pricinglabel" class="form-label">Description Bahasa</label>
            <div class="input-group">
              <quill-editor :options="options" theme="snow" v-model:content="item.description.id" contentType="html"></quill-editor>
            </div>          
          </div>            
        </div>
       
        <hr />
      </div>
      
      <div class="col-1">
        <div class="form-group" style="margin-top: 30px;" v-if="key > 0 && !this.$route.params.id">
          
        <a @click="onClickRemovePricing(key)" class="btn btn-danger btn-xs">
          <i class="fas fa-times" aria-hidden="true"></i>        
        </a>
        </div>             
          
      </div>                  
    </div>
    <div class="row ms-3">
      <div class="col">
        <a @click="onClickAddPricing" class="btn btn-primary btn-sm">Add Plan</a>
      </div>
    </div>

    <div class="mt-4 d-flex justify-content-end">
      <a class="m-0 btn btn-light" href="/products/one-time">
        Cancel
    </a>
      <button
          type="submit"
          name="button"
          class="m-0 btn bg-gradient-success ms-2"
      >
          {{ submitButtonName }}
      </button>
    </div>
  </form>
  </div>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';

  export default {
    data() {
      return {
        unitTypes: ['education', 'customize-trading'],
        record: {
          pricing_models: [{hint: {id: '', en: ''}, label: {id: '', en: ''}, description: {id: '', en: ''}}]
        },
      };
    },
    setup: () => {
      const options = {modules: {toolbar: false}}
      return { options }
    },
    components: {
      QuillEditor
    },
    methods: {
      onSubmitForm() {
        this.onSubmit(this.record)
      },
      onClickAddPricing(){
        this.record.pricing_models.push({hint: {id: '', en: ''}, label: {id: '', en: ''}, description: {id: '', en: ''}})
      },
      onClickRemovePricing(key){
        this.record.pricing_models.splice(key, 1)
      }

    },
    props: {
        titlePage: String,
        subtitlePage: String,
        submitButtonName: String,
        onSubmit: { type: Function },
        toggleModal: { type: Function },
        recordProps: { type: Object }
    },
    watch: {
        recordProps: function (newVal, oldVal) { // watch it
        console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        this.record = newVal
        }
    },
    mounted() {
    
    },
  }
  </script>
<style>
.ql-container.ql-snow {
  width: 100%;
  min-height: 100px;
  border-radius: 8px;
}
</style>
  